module.exports = __webpack_public_path__ + "img/logo.c6241dbb.svg";